import { useMemo } from "react";
import Svg, { Path } from "react-native-svg";
import { Platform, View } from "react-native";

import type { IconProps } from "./types";
export function MapPin({
  size = 24,
  color,
  style,
  ...props
}: Omit<IconProps, "width" | "height" | "viewBox" | "fill">) {
  const defaultColor = useMemo(
    () => (Platform.OS === "web" ? "currentcolor" : "black"),
    []
  );
  const component = (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ? color : defaultColor}
      {...props}
    >
      <Path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
        fill={color ? color : defaultColor}
      />
    </Svg>
  );

  if (style) {
    return <View style={style}>{component}</View>;
  }

  return component;
}
